import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface DesignNibMinusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const DesignNibMinusIcon = ({ className, ...props }: DesignNibMinusIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_580_31078)">
      <mask
        fill="currentColor"
        height="22"
        id="path-1-outside-1_580_31078"
        maskUnits="userSpaceOnUse"
        width="22"
        x="1.17036"
        y="0.941925"
      >
        <rect
          fill="white"
          height="22"
          width="22"
          x="1.17036"
          y="0.941925"
        />
        <path d="M15.1401 2.74759C16.214 1.67365 17.9548 1.67365 19.0288 2.74759L21.1498 4.86868C22.2238 5.94262 22.2238 7.68341 21.1498 8.75735L18.4282 11.479C18.4172 11.5347 18.4044 11.5904 18.3862 11.6451L16.4809 17.3599C16.3416 17.7778 16.0066 18.1015 15.5844 18.2271L3.90668 21.6988L3.71235 21.7427C2.80943 21.8765 2.0284 21.0695 2.19184 20.1714L2.24165 19.9781L6.03364 8.60403C6.15772 8.23216 6.43682 7.93215 6.79926 7.78275L12.187 5.56497C12.2523 5.5381 12.3189 5.51664 12.3862 5.50052L15.1401 2.74759Z" />
      </mask>
      <path
        d="M15.1401 2.74759C16.214 1.67365 17.9548 1.67365 19.0288 2.74759L21.1498 4.86868C22.2238 5.94262 22.2238 7.68341 21.1498 8.75735L18.4282 11.479C18.4172 11.5347 18.4044 11.5904 18.3862 11.6451L16.4809 17.3599C16.3416 17.7778 16.0066 18.1015 15.5844 18.2271L3.90668 21.6988L3.71235 21.7427C2.80943 21.8765 2.0284 21.0695 2.19184 20.1714L2.24165 19.9781L6.03364 8.60403C6.15772 8.23216 6.43682 7.93215 6.79926 7.78275L12.187 5.56497C12.2523 5.5381 12.3189 5.51664 12.3862 5.50052L15.1401 2.74759Z"
        fill="white"
      />
      <path
        d="M15.1401 2.74759L15.4936 3.10121L15.4936 3.10114L15.1401 2.74759ZM21.1498 4.86868L21.5034 4.51513L21.1498 4.86868ZM21.1498 8.75735L21.5034 9.11091L21.1498 8.75735ZM18.4282 11.479L18.0746 11.1255C18.0045 11.1956 17.9568 11.285 17.9376 11.3823L18.4282 11.479ZM18.3862 11.6451L18.8605 11.8032L18.8605 11.8032L18.3862 11.6451ZM16.4809 17.3599L16.0066 17.2018L16.0066 17.2018L16.4809 17.3599ZM15.5844 18.2271L15.7269 18.7064L15.7269 18.7063L15.5844 18.2271ZM3.90668 21.6988L4.01697 22.1864C4.02779 22.184 4.03853 22.1812 4.04917 22.178L3.90668 21.6988ZM3.71235 21.7427L3.78563 22.2373C3.79804 22.2355 3.81039 22.2332 3.82263 22.2304L3.71235 21.7427ZM2.19184 20.1714L1.70765 20.0467C1.70465 20.0583 1.70207 20.0701 1.69992 20.0819L2.19184 20.1714ZM2.24165 19.9781L1.76731 19.8199C1.76364 19.8309 1.76035 19.8421 1.75745 19.8533L2.24165 19.9781ZM6.03364 8.60403L5.55934 8.44579L5.5593 8.4459L6.03364 8.60403ZM6.79926 7.78275L6.60894 7.32039L6.60871 7.32048L6.79926 7.78275ZM12.187 5.56497L11.9968 5.10256L11.9966 5.10261L12.187 5.56497ZM12.3862 5.50052L12.5027 5.98676C12.5924 5.96526 12.6744 5.91936 12.7397 5.85413L12.3862 5.50052ZM15.1401 2.74759L15.4936 3.10114C16.3723 2.22246 17.7965 2.22246 18.6752 3.10114L19.0288 2.74759L19.3823 2.39404C18.1131 1.12483 16.0557 1.12483 14.7865 2.39404L15.1401 2.74759ZM19.0288 2.74759L18.6752 3.10114L20.7963 5.22224L21.1498 4.86868L21.5034 4.51513L19.3823 2.39404L19.0288 2.74759ZM21.1498 4.86868L20.7963 5.22224C21.675 6.10092 21.675 7.52512 20.7963 8.4038L21.1498 8.75735L21.5034 9.11091C22.7726 7.8417 22.7726 5.78433 21.5034 4.51513L21.1498 4.86868ZM21.1498 8.75735L20.7963 8.4038L18.0746 11.1255L18.4282 11.479L18.7817 11.8326L21.5034 9.11091L21.1498 8.75735ZM18.4282 11.479L17.9376 11.3823C17.9284 11.4289 17.9204 11.4612 17.9118 11.4869L18.3862 11.6451L18.8605 11.8032C18.8884 11.7195 18.906 11.6404 18.9187 11.5758L18.4282 11.479ZM18.3862 11.6451L17.9118 11.4869L16.0066 17.2018L16.4809 17.3599L16.9552 17.518L18.8605 11.8032L18.3862 11.6451ZM16.4809 17.3599L16.0066 17.2018C15.9189 17.4646 15.708 17.6687 15.4419 17.7478L15.5844 18.2271L15.7269 18.7063C16.3053 18.5344 16.7643 18.0909 16.9552 17.518L16.4809 17.3599ZM15.5844 18.2271L15.4419 17.7478L3.7642 21.2195L3.90668 21.6988L4.04917 22.178L15.7269 18.7064L15.5844 18.2271ZM3.90668 21.6988L3.7964 21.2111L3.60207 21.255L3.71235 21.7427L3.82263 22.2304L4.01697 22.1864L3.90668 21.6988ZM3.71235 21.7427L3.63907 21.2481C3.07478 21.3317 2.58164 20.8221 2.68376 20.2609L2.19184 20.1714L1.69992 20.0819C1.47515 21.3169 2.54408 22.4213 3.78563 22.2373L3.71235 21.7427ZM2.19184 20.1714L2.67604 20.2961L2.72584 20.1028L2.24165 19.9781L1.75745 19.8533L1.70765 20.0467L2.19184 20.1714ZM2.24165 19.9781L2.71598 20.1362L6.50797 8.76217L6.03364 8.60403L5.5593 8.4459L1.76731 19.8199L2.24165 19.9781ZM6.03364 8.60403L6.50793 8.76228C6.58626 8.52754 6.76219 8.33884 6.98981 8.24501L6.79926 7.78275L6.60871 7.32048C6.11145 7.52545 5.72917 7.93678 5.55934 8.44579L6.03364 8.60403ZM6.79926 7.78275L6.98959 8.24511L12.3773 6.02733L12.187 5.56497L11.9966 5.10261L6.60894 7.32039L6.79926 7.78275ZM12.187 5.56497L12.3772 6.02738C12.4185 6.01037 12.4605 5.99687 12.5027 5.98676L12.3862 5.50052L12.2697 5.01428C12.1773 5.03641 12.0861 5.06583 11.9968 5.10256L12.187 5.56497ZM12.3862 5.50052L12.7397 5.85413L15.4936 3.10121L15.1401 2.74759L14.7866 2.39397L12.0327 5.1469L12.3862 5.50052Z"
        fill="white"
        mask="url(#path-1-outside-1_580_31078)"
      />
      <path
        d="M17.6744 11.4075L15.7691 17.1233C15.7072 17.309 15.5586 17.4529 15.3709 17.5087L3.69348 20.9803C3.22819 21.1186 2.79978 20.676 2.95328 20.2155L6.74467 8.84131C6.79981 8.67588 6.92419 8.54263 7.08543 8.47624L12.472 6.25822C12.696 6.166 12.9535 6.21749 13.1248 6.38876L17.5294 10.7935C17.6901 10.9542 17.7463 11.1919 17.6744 11.4075Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3.29602 20.6016L9.65998 14.2377"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M20.6201 8.22724L17.7916 11.0557L12.8419 6.10592L15.6703 3.27749C16.4514 2.49644 17.7177 2.49644 18.4987 3.27749L20.6201 5.39881C21.4011 6.17986 21.4011 7.44619 20.6201 8.22724Z"
        fill="white"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M11.7812 12.1163C11.1955 11.5305 10.2457 11.5305 9.65992 12.1163C9.07413 12.7021 9.07413 13.6519 9.65992 14.2376C10.2457 14.8234 11.1955 14.8234 11.7812 14.2376C12.367 13.6519 12.367 12.7021 11.7812 12.1163Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M22.8867 18.8868C23.439 18.8868 23.8867 19.3345 23.8867 19.8868C23.8867 20.4391 23.439 20.8868 22.8867 20.8868H16.8867C16.3344 20.8868 15.8867 20.4391 15.8867 19.8868C15.8867 19.3345 16.3344 18.8868 16.8867 18.8868H22.8867Z"
        fill="currentColor"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="0.5"
      />
    </g>
    <defs>
      <clipPath id="clip0_580_31078">
        <rect
          fill="white"
          height="24"
          width="24"
        />
      </clipPath>
    </defs>
  </svg>
);

export default DesignNibMinusIcon;
